import { Component, OnInit, AfterContentInit } from '@angular/core';

import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoriaService } from 'src/app/pages/cadastros/categoria/categoria.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';

@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  providers: [CategoriaService]
})
export class CategoriaComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];

  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isLoading = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private categoriaService: CategoriaService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService
  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('categoria');
  }

  ngOnInit() {
    this.list(); // carrega lista de já cadastrados
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public list(): void {
    this.isLoading = true;
    this.categoriaService.list().subscribe((response: any) => {
      this.cadastrados = response;
      this.setVoids();
      this.isLoading = false;
    });
  }

  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        nome: new FormControl(null, [Validators.required]),
        valor: new FormControl(null, [Validators.required])
      }
    );
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
  }

  public read(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.categoriaService.read(id).subscribe(

      (response: any) => {
        this.form.get('id').setValue(response.id);
        this.form.get('nome').setValue(response.nome);
        this.form.get('valor').setValue(response.valor);
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    if (this.isEditing === false) {

      this.categoriaService.isUniqueNomeCategoria(this.form.get('nome').value).subscribe(

        (isUniqueNomeCategoria: boolean) => {

          if (isUniqueNomeCategoria) {
            this.save();
          } else {
            this.form.get('nome').setErrors({ isNotUniqueNome: true });
            this.isProcessing = false;
          }

        },
        (error: any) => { this.showError(error); }
      );

    } else {
      this.save();
    }
  }

  public save() {

    this.categoriaService.create(this.form.value).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.categoriaService.delete(id).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }

        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }

  public clearValor() {
    this.form.get('valor').setValue(null);
  }

}
